/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownRightIcon20Regular = forwardRef('ArrowADownRightIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M14.19 15.25H6.5a.75.75 0 0 0 0 1.5h8a2.25 2.25 0 0 0 2.25-2.25v-8a.75.75 0 0 0-1.5 0v7.69L4.53 3.47a.75.75 0 0 0-1.06 1.06l10.72 10.72Z" })));
});
